import { ROLE_ADMIN, ROLE_SUPERADMIN, useAuth } from '../../lib/auth';
import NavLink from './NavLink';
import {
    UilBookOpen,
    UilEstate,
    UilFileAlt,
    UilSetting,
    UilShield,
    UilSignOutAlt,
    UilSmileBeam,
    UilUsersAlt,
} from '@iconscout/react-unicons';
import { NavLink as RouterNavLink } from 'react-router';

import VsimavecHeadEmotions from '../../assets/vsimavec-head-emotions.svg';
import { cn } from '../../lib/helpers.ts';

export default function AuthNav() {
    const { logout, user, userHasFullLicense } = useAuth({ tmp: 'AuthNav' });

    const isAdmin = user?.role === ROLE_ADMIN || user?.role === ROLE_SUPERADMIN;
    const isContactPerson = user?.is_institution_contact_person;

    return (
        <nav className="h-full pt-9">
            <ul className="flex h-full flex-col justify-between space-y-1">
                <div className="space-y-1">
                    <NavLink href="/dashboard" icon={UilEstate}>
                        Domů
                    </NavLink>

                    <NavLink
                        href="/zaciname"
                        icon={UilSmileBeam}
                    >
                        Začínáme
                    </NavLink>

                    <NavLink href="/cviceni" icon={UilBookOpen}>
                        Cvičení
                    </NavLink>

                    {/* <NavLink href="/pracovni-listy" icon={UilFileAlt}>
                        Pracovní listy
                    </NavLink> */}

                    {/*<NavLink href="/cviceni/lekce/na-kazdy-den" icon={UilGift}>*/}
                    {/*    Na každý den*/}
                    {/*</NavLink>*/}
                </div>
                <div className="space-y-1">
                    {!isAdmin && !userHasFullLicense && (
                        <RouterNavLink to="/koupit">
                            <button
                                className={cn(
                                    'tour--buy-full-version',
                                    'mb-3 flex flex-col items-center justify-center rounded-2xl border border-[#BCC8DC] bg-gradient-to-tr from-[#D7DEEA] to-[#ECF1F8] p-4',
                                    'transition-shadow',
                                    'hover:shadow-md'
                                )}
                            >
                                <img
                                    src={VsimavecHeadEmotions}
                                    className="mb-3 w-16"
                                    alt="Všímavec"
                                />
                                <span className="text-center font-display text-xl font-semibold text-product-600">
                                    Získejte plnou verzi aplikace
                                </span>
                            </button>
                        </RouterNavLink>
                    )}

                    {isAdmin && (
                        <NavLink
                            href={import.meta.env.VITE_ADMIN_URL}
                            icon={UilShield}
                            target="_blank"
                        >
                            Administrace
                        </NavLink>
                    )}
                    <NavLink href="/nastaveni-instituce" icon={UilUsersAlt}>
                        Organizace
                    </NavLink>
                    <NavLink href="/nastaveni" icon={UilSetting}>
                        Nastavení
                    </NavLink>
                    {/*<NavLink href="#" icon={IconQuestionCircle}>*/}
                    {/*    Pomoc*/}
                    {/*</NavLink>*/}
                    <NavLink icon={UilSignOutAlt} onClick={logout}>
                        Odhlásit se
                    </NavLink>
                </div>
            </ul>
        </nav>
    );
}
